<div class="block_logo" class="full-header-logo">
    <div class="col-12" style="text-align: center;"><a (click)="onClickLogo($event)" title="Home page"><img src="{{domainName}}assets/img/logo.svg"></a></div>
</div>
